var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [_c("b-col", [_c("p", [_vm._v(_vm._s(_vm.$t("frases.want_error")))])])],
        1
      ),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c("b-col"),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                { attrs: { size: "sm" }, on: { click: _vm.onCancel } },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("cancel"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_cancelar"))),
                ]
              ),
              _c(
                "b-button",
                {
                  staticClass: "active ml-2",
                  attrs: {
                    id: "popover-target-1",
                    type: "submit",
                    variant: "info",
                    size: "sm",
                    disabled: _vm.isSubmitting,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.executeError("CURRENT", "ERROR")
                    },
                  },
                },
                [
                  _c("span", [
                    _c("i", { staticClass: "material-icons md-16" }, [
                      _vm._v("send"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("frases.execute_error"))),
                  ]),
                ]
              ),
              _c(
                "b-button",
                {
                  staticClass: "active ml-2",
                  attrs: {
                    id: "popover-target-1",
                    type: "submit",
                    variant: "primary",
                    size: "sm",
                    disabled: _vm.isSubmitting,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.executeError("NEW", "ALL")
                    },
                  },
                },
                [
                  _c("span", [
                    _c("i", { staticClass: "material-icons md-16" }, [
                      _vm._v("send"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("frases.new_execution"))),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }